import EditorCheckListCard from "../../../../components/checklist/EditorCheckListCard";

// Checklist card of the trailer (always shown for trado).
const TradoEditorTrailerCheckList = (props) => {
  const { listProblemData } = props;

  return (
    <>
      {/* CHECK TRAILER */}
      <div className="row-start-start w-full flex-wrap gap-4">
        {/* check trailer */}
        <EditorCheckListCard
          {...props}
          wrapperClassName="elevated-card grow row-start-start !py-4 !px-4 md:grow-0 md:w-[50%]"
          listProblemData={listProblemData.filter(
            (el) => el.label_grup === "trailer"
          )}
          title={"Trailer"}
          labelGrup={"trailer"}
        />
      </div>
    </>
  );
};

export default TradoEditorTrailerCheckList;
